import React, { useEffect } from 'react';
import { css } from "@emotion/react";
import { useQuery } from "@apollo/client";

import logo from '../../images/WTB_logo.png'
import { CORPORATE_URL } from "../../config/config";
import { GET_FEATURE_FLAGS } from "../includes/queries";
import { useAppState } from "../contexts/AppContext";

const Header = () => {
    const [,setAppState] = useAppState();
    const { data: featureFlagsData, loading: featureFlagsLoading, error: featureFlagsError } = useQuery(GET_FEATURE_FLAGS, {
        context: { clientName: "corporate" }
    });

    useEffect(() => {
        if (featureFlagsLoading) {
            return;
        }

        // Always clear isFeatureFlagsLoading once the query settles, even on error. SignIn
        // disables the whole login form while it is true, so an unreachable corporate API must
        // degrade to "no flags", not lock every user out of logging in.
        setAppState({
            featureFlags: featureFlagsData?.featureFlags ?? [],
            isFeatureFlagsLoading: false,
        });
    }, [featureFlagsData, featureFlagsLoading, featureFlagsError, setAppState]);

    return (
        <div css={containerStyle}>
            <a href={CORPORATE_URL} aria-label={"Go to the Writer's Toolbox Home page"}>
                <img src={logo} css={imageStyle} alt={""} />
            </a>
        </div>
    );
}

const containerStyle = css`
    width: 100%;
    height: 87px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 3px 15px #00000029;
    margin-bottom: 20px;
`;

const imageStyle = css`
    height: 28px;
`;

export default Header;
